import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Label } from 'core/components/label';
import useStyles from './policy-changes-list.styles';

function PolicyChangesList({ changes }) {
  const classes = useStyles();

  const getTagText = (type) => {
    switch (type) {
      case 'added':
        return 'Added';
      case 'removed':
        return 'Removed';
      case 'change':
        return 'Changed';
      default:
        return '';
    }
  };

  const getTagClass = (type) => {
    switch (type) {
      case 'added':
        return classes.changeTagAdded;
      case 'removed':
        return classes.changeTagRemoved;
      case 'changed':
        return classes.changeTagChanged;
      default:
        return '';
    }
  };

  return (
    <div>
      {changes.map((item, index) => {
        if (item.type === 'change') {
          return (
            <div key={index} className={classes.changeItem}>
              <div className={classNames(classes.changeTag, classes.changeTagChanged)}>{getTagText(item.type)}</div>
              <Label type="infoValue" className={classes.pipReqestedChangesListItem}>
                {item.friendlyName}:
              </Label>
              <span className={classes.oldValue}>{item.oldValue}</span>
              <span className={classes.changeArrow}>→</span>
              <span className={classes.newValue}>{item.newValue}</span>
            </div>
          );
        }

        if (item.type === 'added') {
          return (
            <div key={index} className={classes.changeItem}>
              <div className={classNames(classes.changeTag, getTagClass(item.type))}>{getTagText(item.type)}</div>
              <Label type="infoValue" className={classes.pipReqestedChangesListItem}>
                {item.friendlyName}:
              </Label>
              <span>added </span>
              <span className={classes.newValue}>{item.addedValue}</span>
            </div>
          );
        }

        if (item.type === 'removed') {
          return (
            <div key={index} className={classes.changeItem}>
              <div className={classNames(classes.changeTag, getTagClass(item.type))}>{getTagText(item.type)}</div>
              <Label type="infoValue" className={classes.pipReqestedChangesListItem}>
                {item.friendlyName}:
              </Label>
              <span>removed </span>
              <span className={classes.oldValue}>{item.removedValue}</span>
            </div>
          );
        }

        return (
          <div key={index} className={classes.changeItem}>
            <div className={classNames(classes.changeTag, getTagClass(item.type))}>{getTagText(item.type)}</div>
            <Label id="value" type="infoValue" className={classes.pipReqestedChangesListItem}>
              {item.text}
            </Label>
          </div>
        );
      })}
    </div>
  );
}

PolicyChangesList.propTypes = {
  changes: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.string.isRequired,
      friendlyName: PropTypes.string,
      oldValue: PropTypes.string,
      newValue: PropTypes.string,
      addedValue: PropTypes.string,
      removedValue: PropTypes.string,
      text: PropTypes.string
    })
  ).isRequired
};

export default PolicyChangesList;
